import api from './api';

export const addEnquiriesData = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
    });
    
    return api.post('/enquiries/add', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const addScheduleCallData = (data) => {
    const formData = new FormData();
    formData.append('phone', data.phone);
    // Add status if required by your backend
    formData.append('status', 'Pending'); 
    
    return api.post('/callbacks/add', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};